<template>
  <div>
    <br />
    <div class="row">
      <div class="col-xl-3 col-12 my-3">
        <label for=""> Prénom </label>
        <input
          type="text"
          v-model="sellerCustomer.firstName"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Nom </label>
        <input
          type="text"
          v-model="sellerCustomer.lastName"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Nom Complet </label>
        <input
          type="text"
          v-model="sellerCustomer.fullName"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Téléphone</label>
        <input
          type="text"
          v-model="sellerCustomer.phone"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">E-mail</label>
        <input
          type="email"
          v-model="sellerCustomer.email"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Référence Vendeur</label>
        <input
          type="text"
          v-model="sellerCustomer.seller_reference"
          class="form-control"
        />
      </div>
    </div>

    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(sellerCustomer)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sellerCustomer: {},
    };
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("sellerCustomer/store", data);
    },
  },
};
</script>
